// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.search-div{
    margin-top:45px;
}




.search-div form{
    position: relative;
    top: 50%;
    left: 30%;
    transform: translate(-50%,-50%);
    transition: all 1s;
    width: 50px;
    height: 50px;
    #background: #661f35cc;
    box-sizing: border-box;
    border-radius: 25px;
    border: 4px black;
    padding: 5px;
}

.search-div input{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;;
    height: 42.5px;
    line-height: 30px;
    outline: 0;
    border: 3;
    display: none;
    font-size: 1em;
    border-radius: 20px;
    padding: 0 20px;
}

.fa{
    box-sizing: border-box;
    padding: 10px;
    width: 42.5px;
    height: 42.5px;
    position: absolute;
    top: 0;
    right: 0;
    border-radius: 50%;
    color: #07051a;
    text-align: center;
    font-size: 1.2em;
    transition: all 1s;
}

.search-div form {
    width: 200px;
    cursor: pointer;
}

.search-div form:hover,
.search-div form:valid{
    width: 200px;
    cursor: pointer;
}

.search-div form input {
    display: block;
}

.search-div form:hover input,
.search-div form:valid input{
    display: block;
}

form .fa {
    background: #07051a;
    color: white;
}

form:hover .fa,
form:valid .fa{
    background: #07051a;
    color: white;
}


.search-div a {
  display: none;
  position: absolute;
  top: 70px;
  bottom:0;
  left: 0;
  right: 0;
  font-size: 20px;
  color: white;
  text-align: center; 
  width: 100%;
}

.search-div form:valid a {
  display: block;
}
`, "",{"version":3,"sources":["webpack://./src/components/Search/search.css"],"names":[],"mappings":";;AAEA;IACI,eAAe;AACnB;;;;;AAKA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,+BAA+B;IAC/B,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,UAAU;IACV,SAAS;IACT,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,aAAa;IACb,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;;IAEI,mBAAmB;IACnB,YAAY;AAChB;;;AAGA;EACE,aAAa;EACb,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB","sourcesContent":["\n\n.search-div{\n    margin-top:45px;\n}\n\n\n\n\n.search-div form{\n    position: relative;\n    top: 50%;\n    left: 30%;\n    transform: translate(-50%,-50%);\n    transition: all 1s;\n    width: 50px;\n    height: 50px;\n    #background: #661f35cc;\n    box-sizing: border-box;\n    border-radius: 25px;\n    border: 4px black;\n    padding: 5px;\n}\n\n.search-div input{\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;;\n    height: 42.5px;\n    line-height: 30px;\n    outline: 0;\n    border: 3;\n    display: none;\n    font-size: 1em;\n    border-radius: 20px;\n    padding: 0 20px;\n}\n\n.fa{\n    box-sizing: border-box;\n    padding: 10px;\n    width: 42.5px;\n    height: 42.5px;\n    position: absolute;\n    top: 0;\n    right: 0;\n    border-radius: 50%;\n    color: #07051a;\n    text-align: center;\n    font-size: 1.2em;\n    transition: all 1s;\n}\n\n.search-div form {\n    width: 200px;\n    cursor: pointer;\n}\n\n.search-div form:hover,\n.search-div form:valid{\n    width: 200px;\n    cursor: pointer;\n}\n\n.search-div form input {\n    display: block;\n}\n\n.search-div form:hover input,\n.search-div form:valid input{\n    display: block;\n}\n\nform .fa {\n    background: #07051a;\n    color: white;\n}\n\nform:hover .fa,\nform:valid .fa{\n    background: #07051a;\n    color: white;\n}\n\n\n.search-div a {\n  display: none;\n  position: absolute;\n  top: 70px;\n  bottom:0;\n  left: 0;\n  right: 0;\n  font-size: 20px;\n  color: white;\n  text-align: center; \n  width: 100%;\n}\n\n.search-div form:valid a {\n  display: block;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
